import { api } from "./axios";

export const aimsApi = {
  getAIInsights: (audioFile: File, title: string) => {
    const formData = new FormData();
    formData.append("audio", audioFile);
    formData.append("title", title);
    return api.post("/aims/get-ai-insights", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 180000,
    });
  },

  getTagResults: (aimsRequestId: string) => {
    return api.get(`/aims/tag-results/${aimsRequestId}`);
  },
};
